<template>
  <el-form ref="form" :model="form" label-width="80px">
    <el-form-item prop="fBalance" label="账户余额">
      <el-input v-model="form.fBalance" disabled />
    </el-form-item>
    <el-form-item prop="fConsumption" label="当前花费">
      <el-input v-model="form.fConsumption" disabled />
    </el-form-item>
    <el-form-item prop="fMinBalance" label="账户底额">
      <el-input v-model="form.fMinBalance" disabled />
    </el-form-item>
    <el-form-item prop="kyBalance" label="可用余额">
      <el-input v-model="form.kyBalance" disabled />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        fBalance: '',
        fConsumption: '',
        fMinBalance: '',
        kyBalance: ''
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$httpPost('GetBalance', {}).then((res) => {
        // console.log(res, "res");
        this.form = res.datalist
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
